import { Component, Input, OnInit } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { ClaimPhotoDocumentInfoModel } from '../../models/ClaimPhotoDocumentInfo';
import { DocumentType } from 'src/app/shared/model/DocumentType';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { DocumentService } from '../../service/document.service';
import { ChangePhotosDocumentTypeRequest } from '../../models/ChangePhotosDocumentTypeRequest';

@Component({
  selector: 'app-change-photos-type-dialog',
  templateUrl: './change-photos-type-dialog.component.html',
  styleUrls: ['./change-photos-type-dialog.component.scss']
})
export class ChangePhotosTypeDialogComponent extends DialogContentBase implements OnInit {

  constructor(
    public dialog: DialogRef, 
    private fb: UntypedFormBuilder,
    public uiNotification: UiNotificationService,
    public documentService: DocumentService) {
    super(dialog);
  }

  @Input() selectedPhotos: ClaimPhotoDocumentInfoModel[];
  @Input() currentDocumentTypeId: number;

  allowedDocumentTypes: number[] = [
    DocumentType.StandardInspectionPhoto,
    DocumentType.RepairProcessPhoto,
    DocumentType.AfterRepairProcessPhoto,
    DocumentType.AddOnPhoto,
    DocumentType.ForEstimationPhoto,
    DocumentType.NonAssociatedPhoto
  ];

  targetSectionForm: UntypedFormGroup;
  targetDocumentTypeId: number;

  ngOnInit(): void {

    this.targetDocumentTypeId = this.currentDocumentTypeId;

    this.targetSectionForm = this.fb.group({
        targetDocumentTypeId: [this.targetDocumentTypeId, [Validators.required,Validators.min(3)]]
      });
    
  }

  changePhotosType(){
    const request: ChangePhotosDocumentTypeRequest = {
      targetDocumentTypeId: this.targetSectionForm.value.targetDocumentTypeId,
      documentInfoIds: this.selectedPhotos.map(p => p.id)
    };

    this.documentService.changeDocumentPhotosType(request).subscribe({
      next: () => { this.dialog.close({ text: 'OK' })},
      error: (error) => { this.uiNotification.showError(error); }
    });
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

}
